import React from 'react';
import { Box, Button } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { HealthAdjustModal, getBarColor } from '../modals/HealthAdjustModal';

export interface MemberHealth {
  current: number;
  max: number;
  onChange: (next: number) => void;
  disabled?: boolean;
}

export const MemberHealthControl: React.FC<MemberHealth> = ({ current, max, onChange, disabled = false }) => {
  const [open, setOpen] = React.useState(false);
  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap', width: '100%' }}>
      <Button
        variant="contained"
        size="small"
        startIcon={<FavoriteIcon sx={{ color: getBarColor(current, max) }} />}
        onClick={() => setOpen(true)}
        disabled={disabled}
        sx={{ minWidth: '100%' }}
      >
        {current}/{max}
      </Button>
      <HealthAdjustModal
        open={open}
        currentHealth={current}
        maxHealth={max}
        onClose={() => setOpen(false)}
        onApply={(next) => {
          onChange(next);
          setOpen(false);
        }}
      />
    </Box>
  );
};
